
// equipment description function
window.mainImage = document.getElementById('mainImage')
window.productTitle = document.getElementById('productTitle')
window.productDescription = document.getElementById('productDescription')

  // function changeImage(imageSrc, title, description) {
  //   window.mainImage.src = imageSrc;
  //   window.productTitle.textContent = title;
  //   window.productDescription.innerHTML = '<p>' + description + '</p>';
  // }

const changeImage = (imageSrc, title, description) => {
  window.mainImage.src = imageSrc;
  window.productTitle.textContent = title;
  window.productDescription.innerHTML = '<p>' + description + '</p>';
}

document.querySelector('button')?.addEventListener('click', function() {
  document.querySelector('.max-w-5xl').style.display = 'none';
});
//end of equipment description function
// console.log('end thumbnail function')